/**
 * ServiceCard
 * -----------
 * Compact card shown when multiple services are matched.
 * All data from service prop (service_registry.py) — nothing hardcoded.
 *
 * Icons  → ./icons.jsx
 * Logic  → ./serviceUtils.jsx (Collapsible, TatTable, StepsList, DocsList)
 */

import { ExternalLink, LockIcon, CheckIcon, ClockIcon} from "./icons";
import { Collapsible, TatTable, StepsList, DocsList } from "./ServiceUtils";

export default function ServiceCard({ service }) {
  const tat          = service.tat          || [];
  const steps        = service.steps        || [];
  const requiredDocs = service.required_docs || [];
  const hasDocs      = requiredDocs.length > 0;

  return (
    <div style={{
      background: "var(--color-background-primary)",
      border: "0.5px solid var(--color-border-tertiary)",
      borderRadius: "var(--border-radius-lg)",
      borderTop: "3px solid #16a34a",
      padding: "14px 16px 16px",
      marginTop: "8px",
      maxWidth: "440px",
      fontFamily: "var(--font-sans)",
    }}>

      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
        <span style={{ fontSize: "10px", fontWeight: "500", letterSpacing: "0.06em", textTransform: "uppercase", color: "#15803d", background: "#dcfce7", padding: "2px 8px", borderRadius: "4px" }}>
          OSR Service
        </span>
        <span style={{ display: "flex", alignItems: "center", gap: "4px", fontSize: "11px", color: "var(--color-text-secondary)" }}>
          <LockIcon /> Login required
        </span>
      </div>

      <h3 style={{ margin: "0 0 5px", fontSize: "15px", fontWeight: "500", color: "var(--color-text-primary)", lineHeight: 1.3 }}>
        {service.name}
      </h3>
      <p style={{ margin: "0 0 12px", fontSize: "13px", color: "var(--color-text-secondary)", lineHeight: 1.55 }}>
        {service.description}
      </p>

      {/* TAT */}
      {tat.length > 0 && (
        <div style={{ marginBottom: "10px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "5px", marginBottom: "8px" }}>
            <ClockIcon />
            <span style={{ fontSize: "11px", fontWeight: "500", textTransform: "uppercase", letterSpacing: "0.05em", color: "var(--color-text-secondary)" }}>
              Processing time (TAT)
            </span>
          </div>
          <TatTable tat={tat} />
        </div>
      )}

      {/* Docs */}
      {!hasDocs && (
        <div style={{ display: "flex", alignItems: "center", gap: "6px", fontSize: "12px", color: "#15803d", background: "#f0fdf4", border: "0.5px solid #bbf7d0", borderRadius: "var(--border-radius-md)", padding: "7px 10px", marginBottom: "10px" }}>
          <CheckIcon /> No documents to upload — just fill and submit
        </div>
      )}
      {hasDocs && (
        <Collapsible label={`Documents needed (${requiredDocs.length})`}>
          <DocsList docs={requiredDocs} />
        </Collapsible>
      )}

      {/* Steps */}
      {steps.length > 0 && (
        <Collapsible label={`How it works (${steps.length} steps)`}>
          <StepsList steps={steps} />
        </Collapsible>
      )}

      <a
        href={service.url}
        target="_blank"
        rel="noopener noreferrer"
        style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px", marginTop: "14px", padding: "9px 0", background: "#16a34a", color: "#fff", borderRadius: "var(--border-radius-md)", fontSize: "13px", fontWeight: "500", textDecoration: "none", boxSizing: "border-box" }}
      >
        Apply Now <ExternalLink />
      </a>
    </div>
  );
}